export default "__VITE_ASSET__Dgt451tn__"